module.exports = __webpack_public_path__ + "img/tg2.46a40c11.png";